import { FETCH_PRODUCT, RESET_PRODUCT } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const productViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT:
      return { data: action.payload };
    case RESET_PRODUCT:
      return initialState;
    default:
      return state;
  }
};

export default productViewReducer;
